import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export const SIDEBAR_WIDTH = 220

export function getAccountAdminSidebarStyles(theme: Theme) {
  return StyleSheet.create({
    sidebar: {
      width: SIDEBAR_WIDTH,
      borderRightWidth: StyleSheet.hairlineWidth,
      borderRightColor: theme.gray[200],
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xs,
    },
    navRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.md,
      borderRadius: theme.borderRadius.md,
      borderWidth: 1,
      borderColor: 'transparent',
      marginHorizontal: theme.spacing.xs,
      marginVertical: 2,
    },
    navRowActive: {
      backgroundColor: theme.background.primary,
      borderColor: theme.gray[300],
    },
    navRowPressed: {
      opacity: 0.88,
    },
    navRowHover: {
      opacity: 0.92,
    },
    navLabel: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.gray[700],
      flex: 1,
    },
    navLabelActive: {
      color: theme.primaryLight,
    },
    navRowLocked: {
      opacity: 0.6,
    },
    navLabelLocked: {
      color: theme.gray[500],
    },
  })
}
